import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="main-footer">
      <div className="footer-container footer-grid">
        <div className="footer-section footer-brand">
          <h3>Wingbeat Paragliding Club</h3>
          <p>Flying the Scottish Borders since 1991</p>
        </div>

        <div className="footer-section">
          <h4>Explore</h4>
          <ul className="footer-links">
            <li><Link to="/sites">Flying Sites</Link></li>
            <li><Link to="/wind-rose">Wind Rose</Link></li>
            <li><Link to="/flight-logs">Flight Logs</Link></li>
            <li><Link to="/news">News</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><a href="https://holfuy.com/en/weather/1801" target="_blank" rel="noopener noreferrer">Weather Station</a></li>
            <li><a href="https://shop.spreadshirt.co.uk/wingbeat" target="_blank" rel="noopener noreferrer">Shop</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>The Club</h4>
          <ul className="footer-links">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/membership">Join Our Club</Link></li>
            <li><Link to="/training">Training</Link></li>
            <li><Link to="/radios">Radios</Link></li>
            <li><Link to="/safety">Safety Guidelines</Link></li>
            <li><Link to="/support">Support the Website</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>More</h4>
          <ul className="footer-links">
            <li><Link to="/links">Links</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
            <li><Link to="/cookies">Cookie Policy</Link></li>
            <li><Link to="/login" className="login-link">Member Login</Link></li>
            <li><Link to="/admin" className="admin-link">Admin</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container">
          <p>&copy; {currentYear} Wingbeat Paragliding Club. All rights reserved.</p>
          <p className="footer-disclaimer">
            Flying is inherently dangerous. Always check weather conditions and fly within your limits.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer